import { MatterFileType } from '@models/matter';
import { Selector } from '@ngxs/store';
import { SelectedMatter } from '@state/matter/matter.selectors';

export class FileCreationSelectors {
	@Selector([
		SelectedMatter.matterFileType,
		SelectedMatter.showBuyerBrokerageCreate,
	])
	static getShowCommissionStep(
		matterFileType: MatterFileType,
		showBuyerBrokerage: boolean,
	) {
		return matterFileType !== MatterFileType.PURCHASE || !!showBuyerBrokerage;
	}
}
